import { useState } from 'react';

import type { ApiFetcherError } from '../../fetcher';
import { useKorintConfig } from './useKorintConfig';

export function useApiCallback<Args extends unknown[]>(
  callback: (...args: Args) => Promise<unknown>,
): [typeof callback, boolean] {
  const [isLoading, setIsLoading] = useState(false);
  const config = useKorintConfig();

  const onError = config.defaultErrorHandler;

  return [
    async (...args: Args): Promise<unknown> => {
      setIsLoading(true);
      try {
        return await callback(...args);
      } catch (error) {
        if (error === 'FORM_ERROR') {
          return;
        }
        onError?.(error as ApiFetcherError<unknown>);
      } finally {
        setIsLoading(false);
      }
    },
    isLoading,
  ];
}
